export default __webpack_public_path__ + "static/media/5.8fbb836a.jpg";